export default "__VITE_ASSET__BQWsuA6H__"